import { Grid, Skeleton, Box, Container } from "@mui/material";

export default function AdvanceTradeFormSkeleton() {
  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="space-between">
            <Skeleton height={10} width="40%" />
            <Skeleton height={10} width="30%" />
          </Box>

          <Box pt={1}>
            <Skeleton height={55} width="100%" variant="rounded" />
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            flexDirection="column"
            mt={1}
          >
            <Skeleton height={10} width="40%" />
            <Skeleton height={10} width="40%" />
          </Box>

          <Box>
            <Skeleton height={30} width="100%" />
          </Box>

          <Box display="flex" flexDirection="column">
            <Skeleton height={10} width="40%" />
            <Box pt={1}>
              <Skeleton height={55} width="100%" variant="rounded" />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}
